export default "__VITE_ASSET__D3KTa0Um__"